// extracted by mini-css-extract-plugin
export default {"link":"OverrideMatchData-link-PKQNa Link-link-RInnp","placeholder":"OverrideMatchData-placeholder-mDuC1","optional":"OverrideMatchData-optional-YwTls"};